import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PageHeader from "../Components/PageHeader";
import SignUpTabs from "../Components/SignUpTabs";
import Select from "react-select";
import { physicianSignUp, specializationsApi } from "../network/Network";
import Swal from "sweetalert2";

const PhysicianSignUpDetail = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const [loading, setLoading] = useState(false);
	const [options, setOptions] = useState([]); // State for options
	const [newFile, setNewFile] = useState("");
	const [fileupload, setFileupload] = useState("");
	const [uploadLoading, setUploadLoading] = useState(false);
	const [formErrors, setFormErrors] = useState([]);
	const [specialize, setSpecialize] = useState([]);
	const [userData, setUserData] = useState({
		experience: "",
		degree_title: "",
		license_number: "",
	});

	const [selectedSpecializations, setSelectedSpecializations] = useState();

	const specialSelection = selectedSpecializations?.map((item) => item?.label);

	const [selectedFile, setSelectedFile] = useState(null);

	const handleChange = (selectedOptions) => {
		setSelectedSpecializations(selectedOptions);
	};

	// Map the data to the required format for react-select
	const formattedOptions = specialize.map((item) => ({
		value: item?.id, // The actual value
		label: item?.title, // The displayed label
	}));

	//   Input Handler
	function handleChangeInput(e) {
		const value = e.target.value;
		setUserData({ ...userData, [e.target.name]: value });
	}
	// ================

	// Ger Specializations
	useEffect(() => {
		specializationsApi().then((res) => {
			setSpecialize(res?.data);
		});
	}, []);

	// upload file
	const handleFileChange = (e) => {
		const file = e.target.files[0];
		setSelectedFile(file);
		// You can perform additional actions here, such as uploading the file.
	};
	const {
		first_name,
		last_name,
		phone,
		countryCode,
		email,
		password,
		getCityid,
		getStateid,
		confirm_password,
		zip_code,
		getCountryid,
		address_type,
		address,
	} = location?.state ?? {};
	console.log(countryCode, "countryCode");
	//   Sign Up Handler
	const SignUpHandler = async (e) => {
		e.preventDefault();
		setLoading(true);

		let isValid = true;
		const errors = {};

		// Validate profile image
		if (!newFile) {
			errors.newFile = ["Profile is required"];
			isValid = false;
		}

		// Validate specializations
		if (!selectedSpecializations || selectedSpecializations.length === 0) {
			errors.selectedSpecializations = ["Specialty is required"];
			isValid = false;
		}

		// Validate experience
		if (!userData?.experience) {
			errors.experience = ["Experience is required"];
			isValid = false;
		}

		// Validate degree title
		if (!userData?.degree_title) {
			errors.degree_title = ["Degree title is required"];
			isValid = false;
		}

		if (!isValid) {
			setFormErrors(errors);
			// setTimeout(() => {
			//   setFormErrors({});
			// }, 3000);
			setLoading(false);
			return;
		}

		const data = {
			first_name,
			last_name,
			email,
			phone: countryCode + phone,
			password,
			confirm_password,
			city: getCityid?.name,
			state: getStateid?.name,
			zip_code,
			country: getCountryid?.name,
			address,
			// specialization: selectedSpecializations,
			specialization: specialSelection,
			experience: userData.experience,
			degree_title: userData.degree_title,
			license_number: userData.license_number,
			profile_image: newFile,
			type: "physician",
		};

		try {
			const response = await physicianSignUp(data);
			Swal.fire({
				position: "center",
				icon: "success",
				text: "Congratulations! Your registration has been successfully completed",
				showConfirmButton: false,
				timer: 1500,
			});
			setFormErrors({});

			console.log(response?.data?.token, "asdjshh");
			navigate("/physician-availablity", {
				state: {
					token: response?.data?.token,
				},
			});

			// navigate("/sign-in");

			setUserData({
				first_name: "",
				last_name: "",
				phone: "",
				email: "",
				password: "",
				confirm_password: "",
				city: "",
				state: "",
				country: "",
				zip_code: "",
				address: "",
			});
		} catch (err) {
			setFormErrors({});

			const errorMessage =
				err?.response?.data?.errors?.email?.[0] ||
				err?.response?.data?.errors?.error?.[0] ||
				"An error occurred. Please try again.";

			Swal.fire({
				position: "center",
				icon: "error",
				text: errorMessage,
				showConfirmButton: false,
				timer: 3000,
			});

			if (errorMessage.includes("already registered")) {
				navigate("/physician-signup");
			}
		} finally {
			setFormErrors({});

			setLoading(false);
		}
	};
	//   ==============

	// Image Upload Handler
	const handleImageUpload = (e) => {
		e.preventDefault();
		const reader = new FileReader();
		const file = e.target.files[0];
		reader.onloadend = () => {
			setNewFile(file);
			setFileupload(reader.result);
		};
		reader.readAsDataURL(file);
		setUploadLoading(true);
	};
	// ============
	return (
		<>
			<Header />
			<PageHeader pagename="SignUp" />
			<section className="signup">
				<div className="container">
					<div className="row">
						<div className="col-lg-6 mx-auto">
							<div className="signup-wrappper">
								<h2 className="main-heading-font dark-color  level-2 text-center mt-3  mb-4">
									Sign up
								</h2>
								<div className="row mt-3">
									<div className="col-lg-12">
										<div className="d-flex align-items-center justify-content-center">
											<SignUpTabs />
										</div>
									</div>
								</div>
								<form>
									<div className="row">
										<div className="col-lg-12">
											<div>
												<Select
													isMulti
													name="specializations"
													isSearchable={false}
													options={formattedOptions} // Ensure `item` is an array of options, as Select expects
													className="basic-multi-select"
													classNamePrefix="select"
													onChange={handleChange}
													value={selectedSpecializations}
													placeholder="Area of Specialty"
												/>
												<p className="forms-error">
													{formErrors?.selectedSpecializations}
												</p>
											</div>
										</div>
									</div>
									<div className="row mt-3">
										<div className="form-group col-lg-12">
											<label htmlFor="">
												<h5 className="primary-medium-font level-7 ">
													Enter Years of Experience
												</h5>
												<input
													type="number"
													className="form-control"
													id="experience"
													placeholder=" Years of Experience"
													name="experience"
													onChange={handleChangeInput}
													value={userData?.experience}
												/>
												<p className="forms-error">{formErrors?.experience}</p>
											</label>
										</div>
									</div>
									<div className="row">
										<div className="form-group col-lg-12">
											<label htmlFor="">
												<h5 className="primary-medium-font level-7 ">
													Enter Degree Title
												</h5>
												<input
													type="text"
													className="form-control"
													id="degree_title"
													placeholder="Degree Title"
													name="degree_title"
													onChange={handleChangeInput}
													value={userData?.degree_title}
												/>
												<p className="forms-error">
													{formErrors?.degree_title}
												</p>
											</label>
										</div>
									</div>
									<div className="row">
										<div className="form-group col-lg-12">
											<label htmlFor="">
												<h5 className="primary-medium-font level-7 ">
													Enter License Number
												</h5>
												<input
													type="text"
													className="form-control"
													id="license_number"
													placeholder="License Number"
													name="license_number"
													onChange={handleChangeInput}
													value={userData?.license_number}
												/>
												<p className="forms-error">
													{formErrors?.license_number}
												</p>
											</label>
										</div>
									</div>
									<div className="row">
										<div className="col-lg-12">
											<div className="upload-input-signup">
												<div className="upload-icon-signup">
													<i className="fa-solid fa-user"></i>
												</div>
												<label
													htmlFor="uploadfile"
													className="custom-file-label"
												>
													{newFile ? newFile?.name : "Upload Profile Image"}
												</label>
												<input
													type="file"
													id="uploadfile"
													className="form-control"
													onChange={handleImageUpload}
												/>
											</div>{" "}
											<p className="forms-error">{formErrors?.newFile}</p>
										</div>
									</div>
									<div className="row">
										<div className="col-lg-12">
											<Link
												className="btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration-none"
												to=""
											>
												<span
													onClick={(e) => SignUpHandler(e)}
													className="loading-btn loading bg-wrapper w-100"
												>
													{loading ? (
														<i className="fa fa-spinner"></i>
													) : (
														"Sign Up"
													)}
												</span>
											</Link>
										</div>
									</div>
								</form>
							</div>
							<h4 className=" level-7 text-center mt-3  primary-regular-font text-decoration-none extra-color-1">
								By Becoming a member, you agree to our{" "}
								<Link
									className="header-link level-7 link-here primary-medium-font text-decoration-none extra-color-1"
									to="/"
								>
									<span className="primary-semibold-font">
										{" "}
										Terms & Conditions{" "}
									</span>{" "}
								</Link>
							</h4>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default PhysicianSignUpDetail;
